/**
 * The artist catalogue. Answers whether an authority exists, never who.
 */
import type {
  ArtistMatchesResponse,
  ArtistsResponse,
} from "@ondo/shared";

import { request } from "./request.ts";

/**
 * The artist catalogue.
 *
 * The response says whether an authority exists and of what kind, never who —
 * see `ondo.search_artists`. Nothing here should ever be joined to a principal.
 */
export const searchArtists = (query: string) =>
  request<ArtistsResponse>(`/artists?q=${encodeURIComponent(query)}`).then(
    (body) => body.artists,
  );

/**
 * "Did you mean one of these?" — the candidates for a name typed in full.
 *
 * Asked once, when the registrant tries to leave the details step having typed
 * an artist's name without picking one. Same boundary as the search above: the
 * rows say that an artist exists and whether some body speaks for them, never
 * which body. An empty array is the answer the form turns into "this artist is
 * not on ONDO at present" — a sentence about the catalogue, not about who holds
 * an account.
 */
export const matchArtists = (name: string) =>
  request<ArtistMatchesResponse>(
    `/artists/matches?name=${encodeURIComponent(name)}`,
  ).then((body) => body.matches);
